export class InvalidOverlayError extends Error {}
